import "bootstrap";
import { useLayoutEffect } from "react";
import "./App.scss";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import {
  RegistrationFormPage,
  RegistrationChangeFormPage,
  RegistrationCancelFormPage,
  LandingRegistrationPage,
  RegistrationSuccessPage,
} from "./components/RegistrationForm";
import { ProtectedRoute } from "./components/Auth";
import { OpenAPI } from "./openapi/edsn-webapi";
import Footer from "./components/Footer";
import { Box } from "@mui/material";
import ReactGA from "react-ga4";

if (process.env.REACT_APP_UNIVERSAL_ANALYTICS_TRACKING_ID) {
  ReactGA.initialize(
    `${process.env.REACT_APP_UNIVERSAL_ANALYTICS_TRACKING_ID}`
  );
}

function App() {

  useLayoutEffect(() => {
    OpenAPI.BASE = process.env.REACT_APP_EDSN_WEBAPI_BASE_URL as string;
  }, []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100%' }}>
      <Box sx={{ marginBottom: "auto", flex: 1 }}>
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={<Navigate to="/registratieformulier" replace />}
            />
            <Route element={null} path="oauth/handler" />
            <Route element={null} path="oauth/silent-callback" />
            <Route
              path="/registratieformulier"
              element={
                <ProtectedRoute>
                  <LandingRegistrationPage />
                </ProtectedRoute>
              }
            ></Route>
            <Route
              path="/registratieformulier/create"
              element={
                <ProtectedRoute>
                  <RegistrationFormPage />
                </ProtectedRoute>
              }
            ></Route>
            <Route
              path="/registratieformulier/change"
              element={
                <ProtectedRoute>
                  <RegistrationChangeFormPage />
                </ProtectedRoute>
              }
            ></Route>
            <Route
              path="/registratieformulier/cancel"
              element={
                <ProtectedRoute>
                  <RegistrationCancelFormPage />
                </ProtectedRoute>
              }
            ></Route>
            <Route
              path="/registratieformulier/success"
              element={
                <ProtectedRoute>
                  <RegistrationSuccessPage />
                </ProtectedRoute>
              }
            ></Route>
          </Routes>
        </BrowserRouter>
      </Box>
      <Box>
        <Footer />
      </Box>
    </Box>
  );
}

export default App;
